import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';
interface FundProduct {
  name: string;
  code: string;
  metrics: {
    label: string;
    value: string;
    suffix?: string;
    prefix?: string;
    color?: string;
  }[];
}

interface FundProductCardProps {
  selectedMetrics: {
    [key: string]: boolean | undefined;
  };
  title: string;
  suggestRatio: string;
  description?: string;
  fundProducts: FundProduct[];
  onSelectChange?: (key: string, checked: boolean) => void;
  checkboxKey?: string;
}

const FundProductCard: React.FC<FundProductCardProps> = ({
  selectedMetrics,
  title,
  suggestRatio,
  description,
  fundProducts,
  onSelectChange,
  checkboxKey = 'fundProducts'
}) => {
  const [currentSelectedMetrics, setCurrentSelectedMetrics] = useState<{
    [key: string]: boolean | undefined;
  }>({});

  useEffect(() => {
    setCurrentSelectedMetrics(selectedMetrics);
  }, [selectedMetrics]);

  const handleCheckboxChange = (checked: boolean) => {
    if (onSelectChange) {
      onSelectChange(checkboxKey, checked);
    }
    setCurrentSelectedMetrics(prev => ({
      ...prev,
      [checkboxKey]: checked
    }));
  };

  return (
    <div className="my-4 rounded-lg border border-[#F0F0F0] p-3">
      {/* 标题和复选框 */}
      <div className="mb-4 flex items-center gap-2">
        <input
          type="checkbox"
          checked={currentSelectedMetrics[checkboxKey] || false}
          onChange={e => handleCheckboxChange(e.target.checked)}
          className="h-4 w-4"
        />
        <span className="text-base font-semibold text-[#1F1F1F]">
          <span>{title}</span>
          <span>（建议配置比例：{suggestRatio}）</span>
        </span>
        {description && (
          <span className="text-sm text-[#8C8C8C]">{description}</span>
        )}
      </div>

      {/* 基金产品列表 */}
      <div className="space-y-3">
        {fundProducts.map((fund, index) => (
          <div
            key={index}
            className="rounded-md border border-[#F0F0F0] bg-white p-3"
          >
            {/* 基金名称和代码 */}
            <div className="mb-3 flex items-center gap-3">
              <div className="flex items-center gap-2">
                <span className="text-base font-semibold text-[#1F1F1F]">
                  {fund.name}
                </span>
                <span className="rounded bg-[#F0F5FF] px-2 py-0.5 text-xs text-[#595959]">
                  {fund.code}
                </span>
              </div>
            </div>

            {/* 指标数据 */}
            <div className="grid grid-cols-3 gap-3">
              {fund.metrics.map((metric, metricIndex) => (
                <div key={metricIndex} className="flex flex-col gap-2">
                  <div className="flex items-center justify-start gap-1">
                    <span
                      className={`text-base font-semibold text-[${metric.color || '#F5222D'}]`}
                    >
                      <CountUp
                        end={Number(metric.value)}
                        suffix={metric.suffix}
                        prefix={metric.prefix}
                        duration={2}
                      />
                    </span>
                  </div>
                  <div className="flex items-center justify-start gap-1">
                    <span className="text-xs text-[#1F1F1F]">
                      {metric.label}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FundProductCard;
